import React from 'react';

const UndoSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.1 9.3c-1.9-.9-4-1.1-5.9-.3-1.5.5-2.7 1.5-3.6 2.8V7.5h-1v6h6v-1H6.4c.8-1.1 1.8-2.1 3.1-2.5 1.7-.6 3.5-.5 5.1.3 2.3 1.2 3.8 3.6 3.8 6.3h1c0-3.2-1.7-6-4.3-7.3"
        />
    </svg>
);

UndoSvg.displayName = 'UndoSvg';
export default UndoSvg;
